import React from 'react'
import './Experience.css'
import a from '../assets/images/l.jpg'
import b from '../assets/images/k.jpg'
import c from '../assets/images/j.jpg'
import d from '../assets/images/e.jpg'
import e from '../assets/images/b.jpg'
import f from '../assets/images/c.jpg'

const Experience = () => {
  // Array of image paths from public folder
  const allImages = [
    a,
    b,
    c,  
    d,
    e,
    f, 
    
  ];

  // Function to get a random image
  const getRandomImage = () => {
    return allImages[Math.floor(Math.random() * allImages.length)];
  };

  return (
    <section className="experience-section" id="about">
      {/* Left side images */}
      <div className="side-images left-images">
        <div className="image-scroll-group">
          <div className="image-box">
            <img src={allImages[0]} alt="Event" />
          </div>
          <div className="image-box">
            <img src={allImages[1]} alt="Event" />
          </div>
          <div className="image-box">
            <img src={allImages[2]} alt="Event" />
          </div>
          <div className="image-box">
            <img src={allImages[3]} alt="Event" />
          </div>
          {/* Duplicate for seamless loop */}
          <div className="image-box" aria-hidden="true">
            <img src={allImages[0]} alt="Event" />
          </div>
          <div className="image-box" aria-hidden="true">
            <img src={allImages[1]} alt="Event" />
          </div>
          <div className="image-box" aria-hidden="true">
            <img src={allImages[2]} alt="Event" />
          </div>
          <div className="image-box" aria-hidden="true">
            <img src={allImages[3]} alt="Event" />
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="experience-content">
        <h2 className="experience-title">The Thought Behind the Experience</h2>
        
        <p className="experience-description">
          Because meaningful connections don't happen randomly — they happen in the right environment.
          <br /><br />
          At Event House, every Mulaqaat is designed with intention. From a curated guest list and balanced crowd to relaxed 
          pacing and comfortable venues, we focus on creating spaces where people can be present and at ease. 
          There are no algorithms, no forced matches, and no digital distractions.
          <br /><br />
          Just thoughtful design, real conversations, and room for connections to unfold naturally.
          <br /><br />
          When people feel comfortable, unpressured, and genuinely engaged — connection follows.
        </p>

        <div className="feature-cards">
          <div className="feature-card">
            <span className="card-number">1</span>
            <h3 className="card-titlee">Designed,<br />Not Random</h3>
            <p className="card-descriptionn">
              Every detail — from guest curation to event flow — is planned to encourage natural interactions.
            </p>
          </div>

          <div className="feature-card">
            <span className="card-number">2</span>
            <h3 className="card-titlee">Built for<br />Comfort</h3>
            <p className="card-descriptionn">
              Premium venues and relaxed settings help people show up as themselves.
            </p>
          </div>

          <div className="feature-card">
            <span className="card-number">3</span>
            <h3 className="card-titlee">Presence<br />Over Profiles</h3>
            <p className="card-descriptionn">
              Offline moments, real conversations, and shared experiences create stronger connections than screens ever could.
            </p>
          </div>
        </div>
      </div>

      {/* Right side images */}
      <div className="side-images right-images">
        <div className="image-scroll-group">
          <div className="image-box">
            <img src={allImages[4]} alt="Event" />
          </div>
          <div className="image-box">
            <img src={allImages[5]} alt="Event" />
          </div>
          <div className="image-box">
            <img src={allImages[0]} alt="Event" />
          </div>
          <div className="image-box">
            <img src={allImages[1]} alt="Event" />
          </div>
          {/* Duplicate for seamless loop */}
          <div className="image-box" aria-hidden="true">
            <img src={allImages[4]} alt="Event" />
          </div>
          <div className="image-box" aria-hidden="true">
            <img src={allImages[5]} alt="Event" />
          </div>
          <div className="image-box" aria-hidden="true">
            <img src={allImages[0]} alt="Event" />
          </div>
          <div className="image-box" aria-hidden="true">
            <img src={allImages[1]} alt="Event" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Experience
